import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MoonStarsFilledSvg = function MoonStarsFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.26 7.029V5.554h-1.474v-1.83h1.474V2.248h1.832v1.474h1.474v1.831h-1.474V7.03zm4.565 6.922a6.31 6.31 0 0 1-8.527-8.527 8.413 8.413 0 1 0 8.527 8.527m-.13-2.832v1.474h1.832v-1.474H22V9.287h-1.474V7.813h-1.832v1.474h-1.474v1.832z",
    clipRule: "evenodd"
  }));
};
export var MoonStarsFilled = function MoonStarsFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MoonStarsFilledSvg
  }));
};